import ProductCardGallery from "./ProductCardGallery";

export default ProductCardGallery;
